import { Field, useFormikContext } from "formik";
import { RichTextEditor } from "components";
import { useFormInputHelpers } from "./useFormInputHelpers";

const FormRichTextInput = ({
  name,
  onChange,
  shouldHaveErrorBehaviorAfterSubmit,
  helperText,
  ...props
}) => {
  const { setFieldValue } = useFormikContext();

  const handleChange = (e) => {
    if (typeof onChange === "function") {
      onChange(e);
      return;
    }
    setFieldValue(name, e);
  };

  const { shouldDisplayError, finalHelperText } = useFormInputHelpers({
    name,
    shouldHaveErrorBehaviorAfterSubmit,
    helperText,
  });

  return (
    <Field
      name={name}
      as={RichTextEditor}
      helperText={finalHelperText}
      isError={shouldDisplayError}
      onChange={handleChange}
      {...props}
    />
  );
};

export default FormRichTextInput;
